import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CREATOR_REPORTS_TOP_RESPONSES } from '../../constants';
import Event from 'models/Event';
import { EventQuestionType } from 'models/EventQuestionType';
import { ResponseSorts } from 'components/creator-report/ResponseSorts';

import { EditSwitch } from './MainContent';
import { EnableSectionUpsell, EditArrowSection } from './MainContent';
import ResponsesList from './ResponsesList';

class TopResponsesSection extends React.PureComponent {
  render() {
    const {
      event,
      responses,
      editing,
      sections,
      isTopResponsesVisuallyEnabled,
      isTopResponsesEnabled,
      handleTopResponsesSwitchChanged,
      handleOnSectionsSet,
      index,
      isPdfRender
    } = this.props;
    const topListLength = 5;
    const hasResponses = (responses && responses.length > 0);
    const questionType = Event.getQuestionType(event);
    const isOpenEnded = EventQuestionType.isOpenEndedType(questionType);
    const votingMode = Event.getVotingMode(event);
    const topFive = hasResponses ? 
      (votingMode === 'star-rating' ? ResponseSorts.getTopRated(responses, topListLength) : ResponseSorts.getTopRanked(responses, topListLength)) 
      : [];

    return (isTopResponsesEnabled || editing) && (
      <div
        className={`report-card-wrapper col ${topFive.length === 0
          ? 'page-break-avoid'
          : ''}`}>
        <div className="row no-gutters">
          <div className={`report-wrapper col${editing ? '-11' : ''}`}>
            <div className={`report-card ${!editing ? 'report-border' : ''}`}>
              {editing && (
                <div className="editing">
                  <EditSwitch
                    id={CREATOR_REPORTS_TOP_RESPONSES}
                    checked={isTopResponsesVisuallyEnabled}
                    onChange={handleTopResponsesSwitchChanged}
                  />
                </div>
              )}
              <div
                className={`card-title text-truncate ${editing && 'editing-title'}`}>
                TOP {topListLength}
              </div>

              {((isTopResponsesEnabled && !editing) ||
                (editing && isTopResponsesVisuallyEnabled)
              ) ?
                <ResponsesList event={event} responses={topFive} isTopRank={ true } isPdfRender={ isPdfRender } />
                : editing
                  ? (
                    <EnableSectionUpsell
                      content={`Show the top ${topListLength} user ${isOpenEnded
                        ? 'responses'
                        : 'comments'} sorted by most popular in the report.`} />
                  )
                  : null
              }
            </div>
            {editing && (
              <EditArrowSection
                name="top_responses"
                sections={sections}
                onSectionsSet={handleOnSectionsSet}
                editing={editing}
                index={index} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

TopResponsesSection.propTypes = {
  event: PropTypes.object.isRequired,
  responses: PropTypes.array.isRequired,
  editing: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  isTopResponsesVisuallyEnabled: PropTypes.bool.isRequired,
  isTopResponsesEnabled: PropTypes.bool.isRequired,
  handleTopResponsesSwitchChanged: PropTypes.func.isRequired,
  handleOnSectionsSet: PropTypes.func.isRequired,
  isPdfRender: PropTypes.bool
};

export default TopResponsesSection;
